// TanStack Query timing presets. Centralizing these stops "magic 30_000" from
// leaking into hook files, and lets us tune cache behaviour in one place.

const ONE_SECOND_MS = 1_000;
const ONE_MINUTE_MS = 60 * ONE_SECOND_MS;

/** Volatile data (activity, presence) — re-fetch eagerly. */
export const STALE_TIME_SHORT = 30 * ONE_SECOND_MS;
/** Boards, columns, cards: 5 min is fine because SSE pushes invalidations. */
export const STALE_TIME_MEDIUM = 5 * ONE_MINUTE_MS;
/** Reference data (labels, members, templates) — rarely changes per session. */
export const STALE_TIME_LONG = 30 * ONE_MINUTE_MS;

export const QUERY_GC_TIME_DEFAULT = 10 * ONE_MINUTE_MS;
export const QUERY_RETRY_DEFAULT = 1;

/** Refresh-token coalescing window: matches Spring Boot token TTL minus a buffer. */
export const TOKEN_REFRESH_SAFETY_WINDOW_MS = 60 * ONE_SECOND_MS;
